(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chevea-newest-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cv-newest-scroll]');
  if (!button) return;
  const section = button.closest('.cv-newest');
  const viewport = section?.querySelector('.cv-newest__viewport');
  if (!viewport) return;
  const card = viewport.querySelector('.cv-newest__card');
  const amount = card ? card.getBoundingClientRect().width * 2 + 36 : viewport.clientWidth;
  viewport.scrollBy({ left: button.dataset.cvNewestScroll === 'previous' ? -amount : amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const selector = '.product-information .product-details h1';
    const observed = new WeakSet();

    const fitTitle = (title) => {
      let size = window.matchMedia('(max-width: 749px)').matches ? 20 : 24;
      title.style.fontSize = `${size}px`;

      while (size > 6) {
        const lineHeight = Number.parseFloat(window.getComputedStyle(title).lineHeight);
        if (title.scrollHeight <= lineHeight * 2 + 1) break;
        size -= 0.5;
        title.style.fontSize = `${size}px`;
      }
    };

    const setup = () => {
      document.querySelectorAll(selector).forEach((title) => {
        if (observed.has(title)) return;
        observed.add(title);
        fitTitle(title);

        const container = title.parentElement;
        if (container && 'ResizeObserver' in window) {
          let lastWidth = container.getBoundingClientRect().width;
          new ResizeObserver(() => {
            const width = container.getBoundingClientRect().width;
            if (Math.abs(width - lastWidth) < 1) return;
            lastWidth = width;
            fitTitle(title);
          }).observe(container);
        }

        new MutationObserver(() => fitTitle(title)).observe(title, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup, { once: true });
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
